import { useEffect } from "react";
import { AppRouter } from "./routers/AppRouter";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { useAppDispatch } from "./store/hooks";
import { UserInfo } from "./interfaces/auth/user.interface";
import { setAuthState } from "./slices/auth/authSlice";
import { FigtreeFonts } from "./fonts";
import {
  buttonStyle,
  buttonStyleContained,
  buttonStyleOutlined,
} from "./helpers/customStyles";

const NavecuadorApp = () => {
  const appDispatch = useAppDispatch();

  useEffect(() => {
    try {
      const stringData = localStorage.getItem("user");
      const userInfo: UserInfo = stringData
        ? JSON.parse(stringData)
        : undefined;
      if (userInfo && userInfo.ok) {
        appDispatch(setAuthState({ isLogged: true, userInfo: userInfo }));
      }
    } catch (error) {
      console.log(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const theme = createTheme({
    palette: {
      primary: {
        main: "#001C85",
      },
      secondary: {
        main: "#C22700",
      },
      success: {
        main: "#46A758",
      },
      error: {
        main: "#E54D2E",
      },
      warning: {
        main: "#FFBA18",
      },
      info: {
        main: "#5EB1EF",
      },
    },
    typography: {
      fontFamily: ["Figtree", "Roboto", "Arial"].join(","),
    },
    overrides: {
      MuiButton: {
        contained: buttonStyleContained as any,
        outlined: buttonStyleOutlined as any,
        text: buttonStyle as any,
      },
      MuiCssBaseline: {
        "@global": {
          "@font-face": [...FigtreeFonts],
          body: {
            backgroundColor: "#f5f7fe",
          },
        },
      },
      MuiPaper: {
        rounded: {
          overflow: "hidden",
          borderRadius: "12px",
        },
      },
      MuiOutlinedInput: {
        root: {
          borderRadius: ".6rem",
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <AppRouter />
    </ThemeProvider>
  );
};

export default NavecuadorApp;
